import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        if (tokenString == null) return;
        const userToken = JSON.parse(tokenString);
        return userToken;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken: any) => {
        if(!userToken) {
            console.error('undefined token');
            return;
        }
        localStorage.setItem('token', JSON.stringify(userToken));
        setToken(userToken);
    };

    return {
        token,
        setToken: saveToken,
    }
}
